import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HostingService} from "../hosting.service";
import {DbResponse} from "../../../../shared/interceptors/db-response";
import {Website} from "../../website";
import {DialogService} from "../../../../../ng2-bootstrap-modal/dialog.service";
import {HostingData} from "../info/hostingData";
import {
  IFcDropdownSelectOption
} from "../../../../shared/components/form-controls/dropdown-select/fc-dropdown-select-option";
import {ChangePhpEngineComponent} from "./change-php-engine-dialog/change-php-engine.component";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {Subscription} from "rxjs";
import * as fromStore from '../../../../store';
import {Store} from '@ngrx/store';
import {EnableHttpsComponent} from "./enable-https-dialog/enable-https.component";
import {RemoveCertificateComponent} from "./remove-certificate/remove-certificate.component";
import {CustomHttpsComponent} from "./custom-https-dialog/custom-https.component";
import {NotifierComponent} from "../../../../shared/components/notifier/notifier.component";
import {NotificationType} from "../../../../shared/components/notifier/notification-type";
import {Notification} from "../../../../shared/components/notifier/notification";
import {HostingDomainData} from "../domains/hostingDomainData";
import {User} from "../../../../user/user";
import {Utils} from "../../../../shared/utils/utils";
import {Config} from "../../../../config/config";
import {filter, first, switchMap, takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";
import enableHttpsOptions from "./enable-https-options.json";
import enableCustomHttpsOptions from "./enable-custom-https-options.json";
import maxExecutionTimeOptions from "./php-config-options-json/max-execution-time-options.json";
import uploadMaxFilesizeOptions from "./php-config-options-json/upload-max-filesize-options.json";
import postMaxSizeOptions from "./php-config-options-json/post-max-size-options.json";
import memoryLimitOptions from "./php-config-options-json/memory-limit-options.json";
import {TextUtils} from "../../../../shared/utils/text-utils";
import features from "./hosting-tools-features.json";
import {UserSubscription} from "../../../../user/user-subscription";
import {DbTextPipe} from "../../../../shared/pipes/db-text.pipe";
import {
  PaidFeatureUpgradeComponent
} from "../../../../shared/components/dialogs/paid-feature-upgrade/paid-feature-upgrade.component";
import {DbModalService} from "../../../../modules/modal/modal";
import {Location} from "@angular/common";
import {HostingPhpConfig} from "../info/hosting-php-config";

@Component({
    selector: 'db-hosting-tools',
    templateUrl: './hosting-tools.component.html',
    styleUrls: ['./hosting-tools.component.scss'],
    host: { '[class.mobile]': 'isMobile', '[class.ds-loading]': 'loading || restartPhpLoading || clearCacheLoading || clearObCacheLoading' },
    standalone: false
})
export class HostingToolsComponent implements OnInit, OnDestroy {

  public isMobile: boolean;
  public hostingInfoData: HostingData;
  public hostingCertificateData: any;
  private _phpEnginePrev: any;
  public website: Website;
  public enableHttpsOptions = enableHttpsOptions;
  public cacheTTLOptions: Array<{label: string, value: number}> = [];
  public enableCustomHttpsOptions = enableCustomHttpsOptions;
  public enableHttps: FormControl;
  public cacheTTL: FormControl;
  public phpEngineOptions: Array<IFcDropdownSelectOption>;
  public phpEngine: FormControl;
  private _subscriptions: Subscription[];
  public clearCacheLoading: boolean;
  public clearObCacheLoading: boolean;
  public cacheTTLloading: boolean;
  public restartPhpLoading: boolean;
  public addAllDomains: HostingDomainData[];
  public removeAllDomains: HostingDomainData[];
  public cache_time = 60;
  public loading: boolean = false;
  public loadingOb: boolean = false;
  public changeMainDomainLoading: boolean = false;
  public enableCache: boolean = false;
  public enableObCache: boolean = false;
  public httpsEnabled: boolean = false;
  public showChangeMainDomain: boolean = false;
  public sslDefaultValue: any;

  public hasHostingBanner: any;
  public user: User;
  public userSubscription: UserSubscription;
  public showText: boolean = true;
  public addText: boolean;
  public addedExcludedPageValue: FormControl;
  public excludePagesLoading: boolean;
  public selectedPageNumber: number;
  public excludePages: Array<string> = [];
  public excludePagesDisable: any;
  public phpIsUpToDate: boolean = true;
  public demoUser: boolean = false;
  public enableBtn: boolean = false;
  public features: string[] = features;
  public showAdvanced: boolean = false;
  public phpConfigs: HostingPhpConfig;
  public phpConfigsLoading: boolean;
  public disablePhpVersionChangeDropdown: boolean;
  public maxExecutionTimeOptions = maxExecutionTimeOptions;
  public uploadMaxFilesizeOptions = uploadMaxFilesizeOptions;
  public postMaxSizeOptions = postMaxSizeOptions;
  public memoryLimitOptions = memoryLimitOptions;
  public phpConfigFormGroup: FormGroup = new FormGroup({
    max_execution_time: new FormControl("300"),
    upload_max_filesize: new FormControl("128"),
    post_max_size: new FormControl("128"),
    memory_limit: new FormControl("256")
  });
  public phpConfigFormGroupDefaultValues = {
    max_execution_time: [300, 600, 900],
    upload_max_filesize: [128, 256, 512],
    post_max_size: [128, 256, 512],
    memory_limit: [256, 512, 1024]
  };
  public disablePhpConfigBtn: boolean = true;
  public websiteId: number;
  public phpChangedValues = {};
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private _route: ActivatedRoute,
    private _location: Location,
    private _router: Router,
    private _hostingService: HostingService,
    private _dialogService: DialogService,
    private _modalService: DbModalService,
    private _store: Store<fromStore.DbStoreState>,
    private _dbText: DbTextPipe
  ) {
  }

  ngOnInit(): void {
    const queryParams: any = (<any>this._route.queryParams).value;
    this.showChangeMainDomain = queryParams.showChangeMainDomain;
    const queryParamsIndex: number = this._router.url.indexOf('?');
    if (queryParamsIndex !== -1) {
      this._location.replaceState(this._router.url.substring(0, queryParamsIndex));
    }
    this.isMobile = window.innerWidth <= 911;
    this.user = this._route.snapshot.parent.parent.data['user'];
    this.userSubscription = this._route.snapshot.parent.parent.data['userSubscription'];
    this.demoUser = Utils.isDemoUser(this.userSubscription, this.user);
    this.hasHostingBanner = localStorage.getItem("showConnectBanner" + this.user.id);
    this.website = this._route.snapshot.parent.parent.data['website'];
    this.websiteId = this.website.isNetwork && !this.website.parentId && this.website.children
    && this.website.children.length ? this.website.children[0] : this.website.id;
    this._setHostingInfoData();
    this.addedExcludedPageValue =
      new FormControl("", [Validators.pattern('^([/\w .-]*)*/?$')]);
    this.enableHttps = new FormControl("generate_certificate");
    this.cacheTTL = new FormControl("");

    this._initializeCacheTTLOptions();
    this.phpEngineOptions = [];
    this.getPHPVersions();

    this._setExcludePages();
    this.phpEngine = new FormControl("");
    this._checkPhpVersionChanged();
    this._getPhpConfigs();
    this._getHostingSettings();
    this.getDomainsList();
    this.addEventHandlers();
  }

  private _initializeCacheTTLOptions(): void {
    this.cacheTTLOptions = [
      { label: this._dbText.transform('text_1Hour'), value: 60 },
      { label: this._dbText.transform('text_3Hours'), value: 180 },
      { label: this._dbText.transform('text_6Hours'), value: 360 },
      { label: this._dbText.transform('text_12Hours'), value: 720 },
      { label: this._dbText.transform('text_1Day'), value: 1440 }
    ];
  }

  private _checkPhpVersionChanged(): void {
    if (localStorage.getItem('changedPhpVersion' + this.websiteId)) {
      const date = localStorage.getItem('changedPhpVersion' + this.websiteId);
      const currentTime = new Date().getTime();
      const timeDifference = currentTime - parseInt(date, 10);
      const thirtyMinutesInMilliseconds = 30 * 60 * 1000; // 30 minutes in milliseconds
      if (timeDifference <= thirtyMinutesInMilliseconds) {
        this.disablePhpVersionChangeDropdown = true;
      }
      else {
        this.disablePhpVersionChangeDropdown = false;
        localStorage.removeItem('changedPhpVersion' + this.website.id);
      }
    }
  }

  private _getHostingSettings(): void {
    this._store.select(fromStore.getHostingSettings(this.websiteId))
      .pipe(
        takeUntil(this._destroyStream$)
      )
      .subscribe((settings: any) => {
        this.setToolsSettings(settings);
      });
  }

  private _setExcludePages(): void {
    this._store.select(fromStore.getCacheExclude(this.websiteId))
      .pipe(
        takeUntil(this._destroyStream$)
      )
      .subscribe((cacheExclude: any) => {
        if (cacheExclude) {
          this.excludePages = cacheExclude;
          this.excludePagesDisable = this.excludePages.length;
        }
      });
  }

  private _getPhpConfigs(): void {
    this._store.select(fromStore.getPhpConfigsLoaded(this.websiteId))
      .pipe(
        filter((loaded: boolean) => !!loaded),
        switchMap(() => this._store.select(fromStore.getPhpConfigs(this.websiteId))),
        filter((configs: any) => !!configs),
        takeUntil(this._destroyStream$)
      )
      .subscribe((data: any) => {
        this.phpConfigs = data;
        if (this.phpConfigs) {
          this.phpConfigFormGroup.setValue({
            max_execution_time: this.phpConfigs.maxExecutionTime,
            upload_max_filesize: this.phpConfigs.uploadMaxFilesize,
            post_max_size: this.phpConfigs.postMaxSize,
            memory_limit: this.phpConfigs.memoryLimit
          });
        }
      });
  }

  public onChangeDropdown(): void {
    this.disablePhpConfigBtn = false;
  }

  public async saveAllPhpConfigs() {
    this.phpConfigsLoading = true;
    const entries = Object.entries(this.phpChangedValues);

    for (const changedValues of entries) {
      await this._saveAdvancedPhpConfigs(changedValues);
    }

    // All PHP configs saved, update data and display success message
    this._updatePhpConfigData();
  }

  private _updatePhpConfigData(): void {
    // Reset the PHP changed values
    this.phpChangedValues = {};

    // Dispatch an action to load PHP configs (assuming this is NgRx)
    this._store.dispatch(new fromStore.LoadPhpConfigs(this.websiteId));

    // Notify the user about successful PHP config changes
    NotifierComponent.notify(new Notification("PHP configs changed successfully", NotificationType.SUCCESS));

    // Set a timeout to disable the PHP config button and stop loading indication after 1 second
    setTimeout(() => {
      this.disablePhpConfigBtn = true;
      this.phpConfigsLoading = false;
    }, 1000);
  }

  private async _saveAdvancedPhpConfigs(changedValues) {
    await new Promise((resolve: Function, reject: Function): void => {
      this._hostingService.updatePhpConfigs(this.websiteId, changedValues)
        .pipe(
          first(response => !!response, null)
        )
        .subscribe(response => {
          resolve(true);
        });
    });

  }

  private _setHostingInfoData(): void {
    this._store.select(fromStore.getInfoLoaded(this.website?.id))
      .pipe(
        filter((loaded: boolean) => !!loaded),
        switchMap(() => this._store.select(fromStore.getInfo(this.website?.id))),
        first()
      )
      .subscribe((hostingInfo: any): void => {
        if (hostingInfo) {
          this.hostingInfoData = hostingInfo;
        }
      });
  }

  private setToolsSettings(settings): void {
    if (settings) {
      this.enableCache = settings.cache_enabled;
      this.enableObCache = settings.object_cache;
      this.cache_time = settings.cache_time;
      this.cacheTTL.setValue(this.cache_time);
      this.phpEngine.setValue(settings.php_version || "7.2");
      this._phpEnginePrev = settings.php_version || "7.2";
      this.phpIsUpToDate = settings && settings.php_version.substring(0, 3) >= "7.4";
    }
  }

  public getDomainsList() {
    if (this.website && this.website.id) {
      this._store.select(fromStore.getDomains(this.websiteId))
        .pipe(
          takeUntil(this._destroyStream$)
        )
        .subscribe((domains: HostingDomainData[]) => {
          this._store.select(fromStore.getCertificates(this.websiteId))
            .subscribe((response: any) => {
              const domainsMap: any = {};
              if (response) {
                this.hostingCertificateData = response;
                response.map((data: any): any => domainsMap[data.domain_name] = data.status);
                this.loading = false;
                if (domains) {
                  this.addAllDomains = domains.filter((domainsList: any): boolean => {
                    if (domainsList.default === 1) {
                      this.httpsEnabled = domainsMap[domainsList.OGname] && domainsMap[domainsList.OGname] === 'active'
                        && !Utils.checkStringInArray(domainsMap[domainsList.OGname], Config.hostnameList); // domainsList.httpsEnabled === 1 //
                    }
                    if ((!domainsMap[domainsList.OGname] || (domainsMap[domainsList.OGname]
                        && domainsMap[domainsList.OGname] === 'inactive'))
                      && !Utils.checkStringInArray(domainsList.OGname, Config.hostnameList)) {
                      return domainsList;
                    }
                    return false;
                  });
                  this.removeAllDomains = domains.filter((domainsList: any): boolean => {
                    if (domainsMap[domainsList.OGname] && domainsMap[domainsList.OGname] === 'active'
                      && !Utils.checkStringInArray(domainsList.OGname, Config.hostnameList)) {
                      return domainsList;
                    }
                    return false;
                  });
                }
                this.editSelectOptions();
              }
            });
        });
    }
  }

  private enableHttpsDialog(value: string): void {
    this._dialogService
      .addDialog(EnableHttpsComponent, {
        website: this.website,
        selectedDialog: value,
        websiteIp: this.hostingInfoData && this.hostingInfoData.hostingBasicInfo.ip,
        allDomains: this.addAllDomains
      })
      .subscribe((confirmed: boolean) => {
        if (confirmed) {
          this._store.dispatch(new fromStore.LoadCertificates(this.websiteId));
          this.getDomainsList();
        } else {
          this.enableHttps.setValue(this.sslDefaultValue, {'emitEvent': false});
        }
      });
  }

  private customHttpsDialog(value: string): void {
    this._dialogService
      .addDialog(CustomHttpsComponent, {
        website: this.website,
        selectedDialog: value
      })
      .subscribe((confirmed: boolean) => {
        if (confirmed) {
          this._store.dispatch(new fromStore.LoadCertificates(this.websiteId));
          this.getDomainsList();
        } else {
          this.enableHttps.setValue(this.sslDefaultValue, {'emitEvent': false});
        }
      });
  }

  private removeHttpsDialog(value: string): void {
    this._dialogService
      .addDialog(RemoveCertificateComponent, {
        websiteId: this.websiteId,
        selectedDialog: value,
        websiteIp: this.hostingInfoData && this.hostingInfoData.hostingBasicInfo.ip,
        allDomains: this.removeAllDomains
      })
      .subscribe((confirmed: boolean) => {
        if (confirmed) {
          this._store.dispatch(new fromStore.LoadCertificates(this.websiteId));
          this._store.dispatch(new fromStore.LoadCloudflareDefaultRecord(this.website.id));
          this.getDomainsList();
        } else {
          this.enableHttps.setValue(this.sslDefaultValue, {'emitEvent': false});
        }
      });
  }


  public getPHPVersions(): void {
    this._hostingService.phpVersions()
      .pipe(
        filter((response: DbResponse): boolean => !!response),
        first()
      )
      .subscribe((response: DbResponse): void => {
        if (response.success) {
          response.data.map(version => {
            const PHPVersion = {
              "label": "PHP Version " + version,
              "value": version
            };
            this.phpEngineOptions.push(PHPVersion);
          });
        }
      });
  }

  public toolsRemoveExludePages(page: string): void {
    this.excludePages.splice(this.excludePages.indexOf(page), 1);
  }

  public editPageValue(index: number): void {
    document.getElementsByClassName('exclude_page' + index)[0].classList.add("showText");
  }


  public addExcludePage($event: any): void {
    if ($event.keyCode === 13 && this.addedExcludedPageValue.value !== "") {
      this.excludePages[this.excludePages.length] = this.addedExcludedPageValue.value;
      this.addedExcludedPageValue.setValue("");
      this.addText = false;
    }
  }

  public editExcludePage(index: number, $event: any): void {
    if ($event.keyCode === 13) {
      this.excludePages[index] =
        (<HTMLInputElement>document.getElementsByClassName('exclude_page_input_' + index)[0]).value;
    }
  }

  public toolsSetExludePages(): void {
    this.excludePagesLoading = true;
    this._hostingService.hostingToolsSetExcludePages(this.website.id, this.excludePages)
      .pipe(
        filter((response: DbResponse): boolean => !!response),
        first()
      )
      .subscribe((response: DbResponse): void => {
        this.excludePagesLoading = false;
        if (response.success) {
          this.excludePagesDisable = this.excludePages.length;
          const message = this.excludePages.length > 1 ?
            TextUtils.getText("text_urls_removed") : TextUtils.getText("text_url_removed");
          NotifierComponent.notify(new Notification(message, NotificationType.SUCCESS));
        } else {
          const errorMessage = this.excludePages.length > 1 ?
            TextUtils.getText("text_urls_hasnt_removed") : TextUtils.getText("text_url_hasnt-removed");
          NotifierComponent.notify(new Notification(errorMessage, NotificationType.DANGER));
        }

      });
  }

  @HostListener('document:click', ['$event']) onDocumentClick($event: any) {
    if (($event.target.classList.contains("active") ||
        ($event.target.parentElement && $event.target.parentElement.classList.contains("active")) ||
        $event.target.classList.value.indexOf('exclude_page_input_') > -1 ||
        ($event.target.parentElement && $event.target.parentElement.classList.value.indexOf('exclude_page_input_') > -1))
      && !this.addText) {
      if (this.selectedPageNumber) {
        this.excludePages[this.selectedPageNumber] =
          (<HTMLInputElement>document.getElementsByClassName('exclude_page_input_' + this.selectedPageNumber)[0]).value;
        document.getElementsByClassName('exclude_page' + this.selectedPageNumber)[0].classList.remove("showText");
        this.selectedPageNumber = null;
      } else {
        this.selectedPageNumber = $event.target.parentElement.classList[0].replace(/\D/g, "");
      }
      this.addText = true;
    } else if (this.selectedPageNumber) {
      this.excludePages[this.selectedPageNumber] =
        (<HTMLInputElement>document.getElementsByClassName('exclude_page_input_' + this.selectedPageNumber)[0]).value;
      document.getElementsByClassName('exclude_page' + this.selectedPageNumber)[0].classList.remove("showText");
      this.selectedPageNumber = null;
      this.addText = false;
    }
  }

  public clearCache(): void {
    this.clearCacheLoading = true;
    this._hostingService.clearCache(this.website.id)
      .pipe(
        filter((response: DbResponse): boolean => !!response),
        first()
      )
      .subscribe((response: DbResponse): void => {
        if (response.success) {
          NotifierComponent.notify(new Notification(TextUtils.getText("text_site_cache_cleared"), NotificationType.SUCCESS));
        } else {
          NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
        }
        this.clearCacheLoading = false;
      });
  }

  public clearObCache(): void {
    this.clearObCacheLoading = true;
    this._hostingService.clearObCache(this.website.id)
      .pipe(
        filter((response: DbResponse): boolean => !!response),
        first()
      )
      .subscribe((response: DbResponse): void => {
        if (response.success) {
          NotifierComponent.notify(new Notification(TextUtils.getText("text_site_ob_cache_cleared"), NotificationType.SUCCESS));
        } else {
          NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
        }
        this.clearObCacheLoading = false;
      });
  }

  public enableCacheForWebsite(): void {
    this.loading = true;
    // Toggle the enableCache value first
    this.enableCache = !this.enableCache;
    
    if (this.enableCache) {
      this._hostingService.enableCache(this.websiteId, this.cache_time)
        .pipe(
          filter((response: DbResponse): boolean => !!response),
          first()
        )
        .subscribe((response: DbResponse): void => {
          if (response.success) {
            this._store.dispatch(new fromStore.LoadHostingSettings(this.websiteId));
            NotifierComponent.notify(new Notification(TextUtils.getText("text_site_cache_enabled"), NotificationType.SUCCESS));
          } else {
            // Revert the toggle on error
            this.enableCache = !this.enableCache;
            NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
          }
          this.loading = false;
        });
    } else {
      this._hostingService.disableCache(this.websiteId)
        .pipe(
          filter((response: DbResponse): boolean => !!response),
          first()
        )
        .subscribe((response: DbResponse): void => {
          if (response.success) {
            this._store.dispatch(new fromStore.LoadHostingSettings(this.websiteId));
            NotifierComponent.notify(new Notification(TextUtils.getText("text_site_cache_disabled"), NotificationType.SUCCESS));
          } else {
            // Revert the toggle on error
            this.enableCache = !this.enableCache;
            NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
          }
          this.loading = false;
        });
    }
  }

  public enableObCacheForWebsite(): void {
    this.loadingOb = true;
    // Toggle the enableObCache value first
    this.enableObCache = !this.enableObCache;
    const _action = this.enableObCache ? 'enable' : 'disable';
    
    this._hostingService.enableObCache(this.websiteId, _action)
      .pipe(
        filter((response: DbResponse): boolean => !!response),
        first()
      )
      .subscribe((response: DbResponse): void => {
        if (response.success) {
          this._store.dispatch(new fromStore.LoadHostingSettings(this.websiteId));
          const message = TextUtils.getText(_action === 'enable' ? 'text_site_ob_cache_enabled' : 'text_site_ob_cache_disabled');
          NotifierComponent.notify(new Notification(message, NotificationType.SUCCESS));
        } else {
          // Revert the toggle on error
          this.enableObCache = !this.enableObCache;
          NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
        }
        this.loadingOb = false;
      });
  }

  public showUpgradeDialog(): void {
      const modal = this._modalService.open(PaidFeatureUpgradeComponent, {height: 600, width: 940, isPaidFeature: true});
      modal.componentInstance.isEcommerce = this.website && this.website.isEcommerceWebsite;
      modal.componentInstance.mode = 'passwordProtect';
      modal.closed.subscribe(() => this._store.dispatch(new fromStore.LoadInfo(this.website.id)));
  }

  public restartPhp(): void {
    this.restartPhpLoading = true;
    this._hostingService.restartPhp(this.website.id)
      .pipe(
        filter((response: DbResponse): boolean => !!response),
        first()
      )
      .subscribe((response: DbResponse): void => {
        if (response.success) {
          NotifierComponent.notify(new Notification(TextUtils.getText("text_php_restarted"), NotificationType.SUCCESS));
        } else {
          NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
        }
        this.restartPhpLoading = false;
      });

  }

  public changePhpEngine(): void {
    this._dialogService
      .addDialog(ChangePhpEngineComponent, {
        websiteId: this.websiteId,
        phpVersion: this.phpEngine.value
      })
      .subscribe((confirmed: any) => {
        if (!confirmed) {
          this.phpEngine.setValue(this._phpEnginePrev);
        } else {
          if (confirmed === 'disable') {
            this.disablePhpVersionChangeDropdown = true;
          }
          this._phpEnginePrev = this.phpEngine.value;
          this._store.dispatch(new fromStore.LoadHostingSettings(this.websiteId));
        }
      });
  }

  private addEventHandlers(): void {
    const phpConfigValues = {
      max_execution_time: 'maxExecutionTime',
      memory_limit: 'memoryLimit',
      post_max_size: 'postMaxSize',
      upload_max_filesize: 'uploadMaxFilesize'
    };
    this._subscriptions = [];

    this._subscriptions.push(this._store.select(fromStore.getWebsite(this.website.id)).subscribe((website: Website) => {
      this.website = website;
    }));

    this._subscriptions.push(
      this.phpConfigFormGroup.valueChanges.subscribe((newValue) => {
        for (const key of Object.keys(newValue)) {
          if (newValue[key] !== this.phpConfigs[phpConfigValues[key]]) {
            this.phpChangedValues[key] = newValue[key];
          }
        }
      })
    );

    this._subscriptions.push(this.phpEngine.valueChanges.subscribe((): void => {
      if (this._phpEnginePrev && this._phpEnginePrev !== this.phpEngine.value && !this.disablePhpVersionChangeDropdown) {
        this._checkPhpVersionChanged();
        this.changePhpEngine();
      }

    }));

    this._subscriptions.push(this.enableHttps.valueChanges.subscribe((): void => {
      if (this.enableHttps.value === "remove_certificate") {
        this.removeHttpsDialog(this.enableHttps.value);
      } else if (this.enableHttps.value === "custom_certificate") {
        this.customHttpsDialog(this.enableHttps.value);
      } else {
        this.enableHttpsDialog(this.enableHttps.value);
      }
    }));
  }

  private editSelectOptions() {
    this.enableHttpsOptions = [
      {
        "label": TextUtils.getText("text_generate_free_ssl"),
        //@ts-ignore
        "value": this.addAllDomains && this.addAllDomains.length ? "generate_certificate" : false,
        "disabled": !(this.addAllDomains && this.addAllDomains.length)
      },
      {
        "label": TextUtils.getText("text_remove_free_ssl"),
        //@ts-ignore
        "value": this.removeAllDomains && this.removeAllDomains.length ? "remove_certificate" : false,
        "disabled": !(this.removeAllDomains && this.removeAllDomains.length),
      },
      {
        "label": TextUtils.getText("text_add_free_ssl"),
        "value": "custom_certificate"
      }
    ];
    const sslDefaultValue = (this.addAllDomains && this.addAllDomains.length) ?
      "generate_certificate" : (this.removeAllDomains && this.removeAllDomains.length ?
        'remove_certificate' : 'custom_certificate');
    this.sslDefaultValue = sslDefaultValue;
    this.enableHttps.setValue(sslDefaultValue, {'emitEvent': false});
  }

  public changeCacheTTL() {
    this.cacheTTLloading = true;
    this._hostingService.changeCacheTTL(this.websiteId, this.cacheTTL.value)
      .pipe(
        filter((response: DbResponse): boolean => !!response),
        first()
      )
      .subscribe((response: DbResponse): void => {
        if (response.success) {
          this.enableCache = true;
          this._store.dispatch(new fromStore.LoadHostingSettings(this.websiteId));
          NotifierComponent.notify(new Notification(TextUtils.getText("text_ttl_changes"), NotificationType.SUCCESS));
        } else {
          NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
        }
        this.cacheTTLloading = false;
      });
  }

  public changeMainDomain() {
    this.changeMainDomainLoading = true;
    this._hostingService.changeMainDomain(this.website.id)
      .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response: DbResponse): void => {
        if (response.success) {
          NotifierComponent.notify(new Notification(response.message, NotificationType.SUCCESS));
        }
        else {
          NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
        }
        this.changeMainDomainLoading = false;
      });
  }

  ngOnDestroy(): void {
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
  }
}
